import { render } from "./CustomCheckboxAndRadio.vue?vue&type=template&id=7c3849b7"
import script from "./CustomCheckboxAndRadio.vue?vue&type=script&lang=ts"
export * from "./CustomCheckboxAndRadio.vue?vue&type=script&lang=ts"
script.render = render

export default script